<!-- use tags -->

import Layout1 from "../../src/routes/game/reduce/+layout.marko";
import Page from "../../src/routes/game/reduce/+page.marko";

<Layout1>
	<Page/>
</>
